import React from "react";
export interface LabelDecorationProps {
    label: string;
}

const LabelDecoration: React.FC<LabelDecorationProps> = props => {
    return <div style={{ borderStyle: "solid", borderWidth: "0px 0px 0px 5px", borderColor: "#2E87FB", paddingLeft: "4px", margin: '12px 4px' }}>{ props.label }</div>;
}

export default LabelDecoration;